import { locales } from './index';
import type { Locale, TranslationDictionary } from './types';

const STORAGE_KEY = 'unit1-admin-locale';

let currentLocale: Locale = 'ru';

export function getLocale(): Locale {
  return currentLocale;
}

export function setLocale(locale: Locale): void {
  currentLocale = locale;
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(STORAGE_KEY, locale);
  }
}

export function initLocale(): Locale {
  if (typeof window !== 'undefined') {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === 'ru' || stored === 'kk' || stored === 'en') {
      currentLocale = stored;
    }
  }
  return currentLocale;
}

export function getIntlLocale(locale: Locale = currentLocale): string {
  switch (locale) {
    case 'kk':
      return 'kk-KZ';
    case 'en':
      return 'en-US';
    default:
      return 'ru-RU';
  }
}

function resolveKey(dictionary: TranslationDictionary, key: string): string | undefined {
  const parts = key.split('.');
  let current: unknown = dictionary;

  for (const part of parts) {
    if (!current || typeof current !== 'object' || !(part in current)) {
      return undefined;
    }
    current = (current as TranslationDictionary)[part];
  }

  return typeof current === 'string' ? current : undefined;
}

export function t(key: string, params?: Record<string, string | number>): string {
  const primary = resolveKey(locales[currentLocale], key);
  const fallback = resolveKey(locales.ru, key);
  let value = primary ?? fallback ?? key;

  if (params) {
    for (const [paramKey, paramValue] of Object.entries(params)) {
      value = value.replaceAll(`{{${paramKey}}}`, String(paramValue));
    }
  }

  return value;
}
